<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="breadcrumb-link" routerLink="/configuration-options"
            >{{ 'configurationOptionModule.configurationOptions' | translate }}
          </a>
        </li>
        <li class="breadcrumb-item active">Index</li>
      </ol>
    </nav>
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'configurationOptionModule.configurationOptions' | translate }}
      </h1>

      <div>
        <button
          type="button"
          class="btn btn-primary"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
          (click)="onClickCreate()"
        >
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->

  <section class="card">
    <div
      class="spinner-border my-5 mx-auto d-block"
      role="status"
      *ngIf="isLoading$ | async"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
    </div>

    <configuration-option-table
      [tableData]="configurationOptions$ | async"
      (onBulkAction)="onBulkAction($event)"
      (onClickRow)="onClickRow($event)"
    ></configuration-option-table>
  </section>
</div>
